import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import CircularLoading from "../loading/CircularLoading";
import { useState } from "react";
import AlertErrors from "../errors/AlertErrors";

export default function OrionSSO({ emailToken, tokenType }) {
  const [loading, setLoading] = useState(false);
  const [openFailure, setOpenFailure] = useState(false);

  const handleAuthRoute = async () => {
    const url = `/api/auth/orion?token=${encodeURIComponent(
      emailToken
    )}&tokenType=${encodeURIComponent(tokenType)}`;
    try {
      const response = await axios.get(url);
      const authUrl = response.data.url;

      window.location.href = authUrl;
    } catch (error) {
      console.log("Error fetching auth URL:", error);
      setOpenFailure(true);
      setLoading(false);
      throw new Error("Error fetching auth URL:", error);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={{ border: "0.5px solid", flex: 1 }} variant="body2" />
        <Typography sx={{ mx: 1 }} variant="body2">
          or
        </Typography>
        <Typography sx={{ border: "0.5px solid", flex: 1 }} variant="body2" />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Button
          onClick={() => {
            setLoading(true);
            handleAuthRoute();
          }}
          sx={{
            width: "100%",
            mt: 1.5,
            backgroundColor: "rgb(75, 126, 244)",
            color: "white",
            textTransform: "none",
            fontSize: "16px",
            height: "44px",
            borderRadius: "5px",
            border: "2px solid",
            borderColor: "rgb(75, 126, 244)",
            ":hover": {
              backgroundColor: "white",
              color: "rgb(75, 126, 244)",
              border: "2px solid",
              borderColor: "rgb(75, 126, 244)",
              fontWeight: 600,
            },
            ":disabled": {
              color: "rgb(75, 126, 244, 0.8)",
              backgroundColor: "white",
            },
          }}
          disabled={loading}
        >
          <img
            style={{
              backgroundColor: "rgb(75, 126, 244)",
              borderRadius: "5px",
              padding: "5px",
              height: "18px",
              width: "18px",
              marginRight: "6px",
              marginTop: "-2px",
            }}
            src="./images/Orion/orion-logo-all-white.svg"
            alt="orion-logo"
          ></img>
          Log in with Orion
        </Button>
        {loading && (
          <CircularLoading
            loading={false}
            size={24}
            loaderSx={{ mt: 1.2, color: "rgb(75, 126, 244)", position: "absolute" }}
          />
        )}
      </Box>
      <AlertErrors
        openFailure={openFailure}
        failureMessage={"Error loading Orion SSO. Please contact support"}
        setOpenFailure={setOpenFailure}
      />
    </Box>
  );
}
